import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Table, Dropdown, Menu } from "antd";
import NumberFormat from "react-number-format";

import { Creators as WagonActions } from "../../../store/ducks/wagon";
import { CardCustom, Title } from "./styles";

import DrawerWagon from "../../../components/drawers/wagon";

import TagStatus from "../../../components/utils/tagStatus";
import { Container as MenuContainer } from "../../../components/utils/table/menu/styles";
import MenuIcon from "../../../components/utils/table/icons/menu";
import ButtonStandard from "../../../components/utils/button";

const Wagon = () => {
  const dispatch = useDispatch();
  const {
    wagon: { data, isLoading },
    app: {
      translation,
      groupSelected: { id: groupId },
      farmSelected: { id: farmId },
    },
  } = useSelector((state) => state);

  useEffect(() => {
    if (groupId && farmId) {
      dispatch(WagonActions.index(groupId, farmId));
    }
  }, [groupId, farmId, dispatch]);

  const { Column } = Table;

  function handleNew() {
    dispatch(WagonActions.showOrHideDrawer());
  }

  function handleEdit(record) {
    dispatch(WagonActions.showOrHideDrawer(record.id));
  }

  function handleActivateOrInactivate(record, action) {
    if (action === "inactivate") {
      dispatch(WagonActions.inactivateWagon(groupId, farmId, record.id));
    } else {
      dispatch(WagonActions.activateWagon(groupId, farmId, record.id));
    }
  }

  function renderMenu(record) {
    return (
      <Menu>
        <Menu.Item key="edit">
          <button onClick={() => handleEdit(record)}>
            {translation.table.menu.edit}
          </button>
        </Menu.Item>
        {record.status === "Active" ? (
          <Menu.Item key="inactivate">
            <button
              onClick={() => handleActivateOrInactivate(record, "inactivate")}
            >
              {translation.table.menu.inactivate}
            </button>
          </Menu.Item>
        ) : (
          <Menu.Item key="activate">
            <button
              onClick={() => handleActivateOrInactivate(record, "activate")}
            >
              {translation.table.menu.activate}
            </button>
          </Menu.Item>
        )}
      </Menu>
    );
  }

  return (
    <CardCustom>
      <Row type="flex" justify="space-between" style={{ marginBottom: "19px" }}>
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Title>{translation.wagon.table.title}</Title>
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} align="right">
          <ButtonStandard buttonType="addNew" onClick={handleNew}>
            {translation.wagon.buttonNew}
          </ButtonStandard>
        </Col>
      </Row>
      <Row type="flex">
        <Table
          loading={isLoading}
          rowKey="id"
          size="small"
          dataSource={data !== null ? data : []}
          scroll={{ x: true }}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: 10,
            pageSizeOptions: ["10", "20", "30", "100"],
          }}
          style={{ width: "100%", margin: "0" }}
        >
          <Column
            title={translation.wagon.table.columns.name}
            dataIndex="name"
            key="name"
            align="left"
            sorter={(a, b) => (a.name || "").localeCompare(b.name || "")}
          />
          <Column
            title={translation.wagon.table.columns.integrationCode}
            dataIndex="integrationCode"
            key="integrationCode"
            align="left"
            sorter={(a, b) =>
              (a.integrationCode || "").localeCompare(b.integrationCode || "")
            }
            render={(text) => text || "-"}
          />
          <Column
            title={translation.wagon.table.columns.capacityKg}
            dataIndex="capacityKg"
            key="capacityKg"
            align="right"
            sorter={(a, b) => (a.capacityKg || 0) - (b.capacityKg || 0)}
            render={(value) =>
              value != null ? (
                <NumberFormat
                  value={value}
                  displayType="text"
                  decimalScale={2}
                  fixedDecimalScale
                  decimalSeparator=","
                  thousandSeparator="."
                />
              ) : (
                "-"
              )
            }
          />
          <Column
            title={translation.wagon.table.columns.observations}
            dataIndex="observations"
            key="observations"
            align="left"
            render={(text) => text || "-"}
          />
          <Column
            title={translation.wagon.table.columns.status}
            dataIndex="status"
            key="status"
            align="left"
            sorter={(a, b) => (a.status || "").localeCompare(b.status || "")}
            render={(status) =>
              status === "Active" ? (
                <TagStatus
                  background="#C5F1CA"
                  borderColor="#106518"
                  color="#106518"
                >
                  {translation.status.active}
                </TagStatus>
              ) : (
                <TagStatus
                  background="#FBC7C7"
                  borderColor="#D44C4C"
                  color="#D44C4C"
                >
                  {translation.status.inactive}
                </TagStatus>
              )
            }
          />
          <Column
            align="left"
            width={50}
            render={(text, record) => (
              <Dropdown
                overlay={renderMenu(record)}
                trigger={["click"]}
                key={record.id}
              >
                <MenuContainer>
                  <MenuIcon />
                </MenuContainer>
              </Dropdown>
            )}
          />
        </Table>
      </Row>
      <DrawerWagon />
    </CardCustom>
  );
};

export default Wagon;
